import { useTranslations } from 'next-intl';

import Card from '@commons/components/Card';
import DrupalImage from '@commons/components/Image/Drupal';
import TopoPatternImage from '@commons/components/Image/TopoPattern';
import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';
import { TEASER_DISPLAY_IMAGE_SIZES } from '@commons/pagebuilder/nodes/images';

import type { WebinarNodeProps } from '.';
import { WebinarNodeLink } from './GatedDrawer';

/**
 * Webinar node component for the Teaser display type.
 */

const WebinarNodeTeaser = (props: WebinarNodeProps) => {
  const t = useTranslations('nodes.webinar');

  const { alias, image, title, customDate, link, format, customLabel, isGated } = props;

  const upperTitle = customLabel ? customLabel : format ? format.name : t('label');

  const renderedImage = image ? (
    <DrupalImage {...image} sizes={TEASER_DISPLAY_IMAGE_SIZES} />
  ) : (
    <TopoPatternImage alt={title} sizes={TEASER_DISPLAY_IMAGE_SIZES} />
  );

  const renderedContent = (
    <Card gap="xs" justify="space-between" direction={{ xs: 'column', md: 'row' }} disabled={!link}>
      <Flex.Item width={{ xs: 12, md: 6 }}>{renderedImage}</Flex.Item>
      <Flex gap="sm" width={{ xs: 12, md: 6 }} justify="space-between" direction="column">
        <Flex.Item>
          <Text as="h6" level="label-md" transform="uppercase" marginBottom="xxs">
            {upperTitle}
          </Text>
          <Card.Title>{title}</Card.Title>
        </Flex.Item>
        <Text level="body-xs" transform="uppercase" marginBottom="none">
          {customDate}
        </Text>
      </Flex>
    </Card>
  );

  if (link) {
    return (
      <WebinarNodeLink alias={alias} link={link} isGated={isGated}>
        {renderedContent}
      </WebinarNodeLink>
    );
  }

  return renderedContent;
};

export default WebinarNodeTeaser;
